import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVectorPolygon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.306,12.863l8.526,5.209",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.032,8.578l-2.84,8.838",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.832,4.34l4.048,1.579",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.49px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.004,9.099l4.66,-3.448",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.766,19.66c0,-1.239 -1.032,-2.244 -2.304,-2.244c-1.272,0 -2.304,1.006 -2.304,2.244c0,1.239 1.032,2.244 2.304,2.244c1.272,0 2.304,-1.006 2.304,-2.244Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.234,11.073c0,-1.239 -1.032,-2.244 -2.304,-2.244c-1.272,0 -2.304,1.006 -2.304,2.244c0,1.239 1.032,2.244 2.304,2.244c1.272,0 2.304,-1.006 2.304,-2.244Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.832,4.34c0,-1.239 -1.032,-2.244 -2.304,-2.244c-1.272,0 -2.304,1.006 -2.304,2.244c0,1.239 1.032,2.244 2.304,2.244c1.272,0 2.304,-1.006 2.304,-2.244Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.374,6.584c0,-1.239 -1.032,-2.244 -2.304,-2.244c-1.272,0 -2.304,1.006 -2.304,2.244c0,1.239 1.032,2.244 2.304,2.244c1.272,0 2.304,-1.006 2.304,-2.244Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgVectorPolygon;
